import React, { useState, useEffect } from "react";
import Layout from "../components/Layout";
function Blog() {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    
    window.scrollTo(0,0)

    fetch(
      "https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@lae622"
    )
      .then((res) => res.json())
      .then((data) => {
        setPosts(data.items);
      });

    return () => {};
  }, []);
  
  return (
    <Layout>
      <div className="text-white">
        <div className="h-screen xl:pt-10 pt-[3.5rem] md:pt-0">
          {" "}
          <div className="h-3/4" data-aos='zoom-in-up'>
            <lottie-player
              src="https://assets4.lottiefiles.com/packages/lf20_4sabgt2r.json"
              background="transparent"
              speed="1"
              loop
              autoplay
            ></lottie-player>
          </div>
          <p data-aos='fade-right' className="ds xl:text-6xl lg:text-5xl md:text-xl text-8xl 2xl:text-7xl font-semibold text-center">
            {" "}
            Repetition + Refinement = Growth 
          </p>
        </div>
        <div data-aos="zoom-in" className="  font-bold text-center bg-ph mx-20 p-3 text-white rounded-tl-full rounded-br-full md:mx-5  md:p-[1rem] d xl:text-6xl lg:text-5xl md:text-2xl 2xl:text-8xl text-[8rem]">
          <h1 className="">THE KEY IS</h1>
          <h1 className="">COMMUNICATION</h1>
        </div>
      </div>
      <div className="grid mt-20 md:grid-cols-1 grid-cols-3 items-center justify-center gap-10 mx-20 md:mx-5">
        {posts?.map((p) => {
          return (
            <div data-aos="zoom-in" key={p.title} className="">
              <div className="relative shadow-2xl shadow-rb border-4 mb-4 text-center rounded-tr-3xl rounded-bl-3xl border-gray-400">
                <div className="flex items-center justify-center">
                  <img
                    className="h-[20rem] w-full rounded-tr-3xl rounded-bl-3xl "
                    src={p.thumbnail}
                    alt=""
                  />
                </div>
                <div className="absolute inset-0 flex items-center justify-center flex-col opacity-0 bg-black hover:opacity-80 rounded-tr-3xl rounded-bl-3xl  p-1">
                  <h1 className="text-4xl font-semibold text-white">
                    {p.title}
                  </h1>
                  <button className="border-2 rounded border-white py-2 hover:bg-green-500 px-5 mt-5 text-white">
                    <a href={p.link} target="_blank">
                      Read
                    </a>
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </Layout>
  );
}

export default Blog;
